module.exports = __webpack_public_path__ + "img/all-topics.9be80399.png";